import { render, staticRenderFns } from "./ReservationView.vue?vue&type=template&id=4832b47a"
import script from "./ReservationView.vue?vue&type=script&lang=js"
export * from "./ReservationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports